import React, { Component } from 'react';
import Input from '../Input/index';
import  Dropdown  from 'Components/Dropdown';
import { IoLogoWhatsapp } from "react-icons/io";

//import styles from './styles.scss';
import { TAT_UNITS } from 'Constants/commonConstants';
import { formatToINR } from 'Utils/transform';
import ActionLoader from '../ActionLoader/index';
import Moment from 'moment';

export default class BidHistoryPopUp extends Component {

    constructor(props) {
        super(props);
    };

    componentDidMount() {
        const {tripId, transporterId, linerId} = this.props;
        this.props.fetchBids(tripId, transporterId, linerId);
    }

    
    render() {
        const {  tripBids, rfqType } = this.props;
        return (
            <div className="pa z-3 popup-container" >
                <div className="tLeft box-shadow bg-white br-5 pt-20 pl-20 pr-15 pb-15 z-1 ">
                    {
                        tripBids.dataFetching && <ActionLoader/>
                    }
                    {
                        !tripBids.dataFetching && <div className="flex flex-row mt-15">
                            <div className="flex-1 ">
                                <div className="section-sub-header-color fBold fs-14 mb-10 op-5">
                                    Bid History
                                </div>
                                <div className="ht-100 overflowAuto">
                                {
                                    tripBids.bids.map((bid, index) => {
                                        let price = (bid.price) ? bid.price : bid.counterPrice;
                                        return <div key={index} className="fs-12 section-sub-header-color  mb-10">
                                                <span>{index + 1}</span> 
                                                <span className="ml-10"> {formatToINR(price)} </span>
                                                <span className="ml-10"> {Moment(bid.created).format("DD MMM YYYY hh:mm:ss A")} </span>
                                                <span className="ml-10">{bid.bidHistoryStatus}</span>
                                                {bid.bidWhatsapp && <IoLogoWhatsapp className="ml-10" style={{ color: "#25D366" }} size={15}/>}
                                                {bid.remarks && <span className="ml-10">{bid.remarks}</span>}
                                            </div>
                                    })
                                }
                                </div>
                            </div>
                            <div className="ml-10">
                                <div className="section-sub-header-color fBold fs-14 mb-10 op-5">
                                    Bid Rules
                                </div>
                                <div className="ht-100 overflowAuto">
                                {
                                    tripBids.rules.map((rule, index) => {
                                        return <div key={index} className="fs-12 section-sub-header-color  mb-10">
                                                <span > { rule.name} </span>
                                            </div>
                                    })
                                }
                                </div>
                            </div>
                        </div>
                    }
                    
                </div>
            </div>
        )
    }
}
